export default {"src":"/_next/static/media/macos.ae079630.svg","height":48,"width":154,"blurWidth":0,"blurHeight":0};